module.exports = __webpack_public_path__ + "static/assets/fe2fa294bd666c5ca5f19795226851e4.svg";